import React from "react";
var __jsx = React.createElement;
import { faCircleInfo, faPlus } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import Tag from "./Tag";
import CheckboxList from "../FormComponents/CheckboxList";
import { clone, get, set } from "lodash";
import Button from "../common/Button";
import { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
var FindingsSelector = function FindingsSelector(props) {
  var findings = props.findings,
    value = props.value,
    title = props.title,
    description = props.description,
    onChange = props.onChange,
    disabled = props.disabled,
    category = props.category,
    disabledValues = props.disabledValues;
  var _useState = useState(false),
    open = _useState[0],
    toggleOpen = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onChangeFinding = function onChangeFinding(val, section) {
    var _value = clone(value);
    set(_value, [section], val);
    onChange(_value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tag, {
    label: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faPlus
    }), " ", t("more_findings")),
    onClick: function onClick() {
      return toggleOpen(!open);
    },
    isSelected: false,
    disabled: disabled,
    mapping: false
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("absolute bottom-0 flex flex-col left-0 bg-gray-100 dark:bg-gray-800 dark:sm:bg-gray-900 rounded-t-12 border border-gray-600 text-white w-full h-3/4 z-50", {
      hidden: !open
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-gray-800 dark:text-gray-100"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start text-gray-500 text-md"
  }, /*#__PURE__*/React.createElement("div", null, description), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleInfo,
    className: "ml-3 text-md"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-auto px-5 overflow-y-auto scrollbar-light dark:scrollbar"
  }, Object.keys(findings).map(function (section) {
    var _findingObj = get(findings, [section], []);
    var _options = _findingObj.map(function (f) {
      return {
        label: t("mapping.".concat(f)),
        value: f,
        disabled: disabledValues.includes(f)
      };
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "my-3",
      key: section
    }, /*#__PURE__*/React.createElement(CheckboxList, {
      id: category,
      label: t("mapping.".concat(section)),
      options: _options,
      value: get(value, [section], []),
      onChange: function onChange(val) {
        return onChangeFinding(val, section);
      },
      className: "text-base",
      labelClassName: "text-md uppercase font-semibold !pb-2"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-col p-4 mb-3"
  }, /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    isLoading: false,
    className: "mt-1 w-auto px-8",
    onClick: function onClick() {
      return toggleOpen(!open);
    }
  }, t("button.done")))));
};
export default FindingsSelector;